import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen relative">
      {/* Background image with blur */}
      <div 
        className="fixed inset-0 bg-cover bg-center bg-no-repeat -z-10 vb-page-bg"
        style={{ 
          filter: 'blur(2px)'
        }}
      />
      
      <div className="text-center relative z-10">
        <div className="inline-block animate-spin rounded-full h-16 w-16 border-b-2 border-yellow-900 mb-4"></div>
        <h2 className="text-2xl font-bickham-script-pro text-yellow-900 mb-2">Van Belle</h2>
        <p className="text-yellow-800">Loading our delicious chocolates...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;